import { jsx, jsxs } from "react/jsx-runtime";
import { Spread, Box, Stack, Heading } from "braid-design-system";
import { StepperProgressPoint } from "../StepperProgressPoint/index.mjs";
import { stepper } from "./index.css.mjs";
const StepperProgress = ({
  activeStepIndex,
  stepNames,
  onClickProgressPoint,
  maxStepIndexVisited
}) => /* @__PURE__ */ jsx(Spread, { space: "xsmall", children: stepNames.map((stepName, index) => {
  const onClick = index <= maxStepIndexVisited ? onClickProgressPoint : void 0;
  return /* @__PURE__ */ jsx(
    StepperProgressPoint,
    {
      activeStepIndex,
      stepName,
      stepIndex: index,
      onClick,
      maxStepIndexVisited
    },
    stepName
  );
}) });
const StepHeader = ({
  title,
  stepNames,
  activeStepIndex,
  onClickProgressPoint,
  maxStepIndexVisited,
  stepHeaderClassName
}) => {
  const shouldShowStepper = stepNames.length > 1;
  if (!title && !shouldShowStepper) {
    return null;
  }
  return /* @__PURE__ */ jsx(Box, { background: "surface", className: stepHeaderClassName, children: /* @__PURE__ */ jsxs(Stack, { space: "large", align: "center", children: [
    title ? /* @__PURE__ */ jsx(Heading, { level: "3", children: title }) : null,
    shouldShowStepper ? /* @__PURE__ */ jsx(Box, { className: stepper, children: /* @__PURE__ */ jsx(
      StepperProgress,
      {
        activeStepIndex,
        stepNames,
        onClickProgressPoint,
        maxStepIndexVisited
      }
    ) }) : null
  ] }) });
};
export {
  StepHeader
};
